if (process.env.BUILD_GC === 'activity' || process.env.BUILD_GC === 'cicp') {
  module.exports = require('./activity')
} else {
  module.exports = null
}
